<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import aiPhoto from '@/mixins/aiPhoto'
import _ from 'lodash'
import photosHelper from '@/mixins/photosHelper'

export default {
  name: 'App',
  mixins: [aiPhoto, photosHelper],
  async mounted () {
    console.log('Inside App created this.$route.params', this.$route.params)
    this.updateWindowWidth()
    window.addEventListener('resize', this.updateWindowWidth)
    this.applyLocaleDirection(this.$i18n.locale)
    this.handleHotjar()
  },
  computed: {
    ...mapGetters({
      selfie: 'selfie/GET_SELFIE'
    })
  },
  methods: {

    updateWindowWidth () {
      console.log('Inside updateWindowWidth, window.innerWidth', window.innerWidth)
      this.$store.commit('global/SET_WINDOW_WIDTH', window.innerWidth)
    },
    applyLocaleDirection (locale) {
      const dir = locale === 'he' ? 'rtl' : 'ltr'
      document.documentElement.setAttribute('dir', dir)
      document.documentElement.setAttribute('lang', locale)
    },
    handleHotjar () {
      const isDashboard = this.$route.path.startsWith('/dashboard')
      if (isDashboard || document.getElementById('hotjar-script')) return

      const hostname = window.location.hostname
      const hotjarIds = []

      // Hotjar site principal
      hotjarIds.push(5234115)

      // Hotjar Faiceme
      if (hostname.includes('faice.me') || hostname.includes('faiceme')) {
        hotjarIds.push(6717726)
      }

      hotjarIds.forEach((hjid, index) => {
        const scriptId = index === 0 ? 'hotjar-script' : `hotjar-script-${hjid}`
        if (!document.getElementById(scriptId)) {
          const script = document.createElement('script')
          script.id = scriptId
          script.async = true
          script.innerHTML = `
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:${hjid},hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `
          document.head.appendChild(script)
        }
      })
    }
  },
  watch: {
    '$i18n.locale' (locale) {
      this.applyLocaleDirection(locale)
    },
    selfie: {
      handler (val) {
        if (!_.isEmpty(_.get(val, '_id'))) {
          console.log('Inside App watch selfie -  val._id, val.event', val._id, val.event)
          const eventIO = `event:${val.event}-selfie:${val._id}`
          if (this.$socket && !this.$socket._callbacks[`$${eventIO}`]) {
            console.log('Launch socket !!!')
            this.$socket.on(eventIO, async (data) => {
              console.log('Inside $socket - data eventIO', data, eventIO)
              this.getMyPhotosAI()
            })
          }
        }
      },
      immediate: true,
      deep: true
    },
    '$route.params': {
      async handler (val) {
        if (val.eventId) {
          console.log('test')
          this.$store.commit('event/SET_LOADING_EVENT', true)
          const event = await this.$axios.get(`event/${val.eventId}`)
          this.$store.commit('event/SET_CURRENT_EVENT', event.data.event)
          this.$store.commit('event/SET_LOADING_EVENT', false)
          console.log('event', event)
        }
      },
      immediate: true
    },
    '$route.path': {
      handler (val) {
        console.log('Inside $route.path - val', val)
        this.resetSelectionPhotos()
        this.handleHotjar()
      }
    }
  }
}
</script>

<style lang="scss">
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

.btn {
  display: inline-block;

  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.btn-primary {
  color: #333!important;
  border: 1px solid #333;
  background: #ffffff;
}
.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.pre {
  white-space: pre-line;
}
</style>
